import { render } from "./HealthInsurance.vue?vue&type=template&id=6ecf0958"
import script from "./HealthInsurance.vue?vue&type=script&lang=js"
export * from "./HealthInsurance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__